var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { defineMetadata } from '../libs';
import { FLAG, FORMAT_TYPE } from './const';
import { createWrapperDOM } from './utils';
var SylSchema = /** @class */ (function () {
    function SylSchema() {
        this.name = '';
    }
    SylSchema = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.BLOCK)
    ], SylSchema);
    return SylSchema;
}());
var Formattable = /** @class */ (function (_super) {
    __extends(Formattable, _super);
    function Formattable(editor, props) {
        var _this = _super.call(this) || this;
        _this.props = {};
        _this.editor = editor;
        props && (_this.props = props);
        return _this;
    }
    return Formattable;
}(SylSchema));
var Block = /** @class */ (function (_super) {
    __extends(Block, _super);
    function Block() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'block';
        _this.content = 'inline*';
        _this.inline = false;
        _this.defining = true;
        _this.draggable = false;
        _this.selectable = false;
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs, Boolean(_this.content)); };
        return _this;
    }
    Block.prototype.tagName = function (node) {
        return 'div';
    };
    Block = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.BLOCK)
    ], Block);
    return Block;
}(Formattable));
/**
 * used to describe sematic inline, same as `inline` in css
 * `notClear` declares that it shouldn't be cleared by `SylApi.clearFormat`
 * `notStore` declares that it wouldn't be stored after deletion
 */
var Inline = /** @class */ (function (_super) {
    __extends(Inline, _super);
    function Inline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs, true); };
        return _this;
    }
    Inline.prototype.tagName = function (node) {
        return 'span';
    };
    Inline = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.INLINE)
    ], Inline);
    return Inline;
}(Formattable));
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    function Atom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLeaf = true;
        _this.draggable = true;
        return _this;
    }
    Atom = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.ATOM)
    ], Atom);
    return Atom;
}(Formattable));
var BlockAtom = /** @class */ (function (_super) {
    __extends(BlockAtom, _super);
    function BlockAtom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'block';
        _this.inline = false;
        _this.isolating = true;
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs); };
        return _this;
    }
    BlockAtom.prototype.tagName = function (node) {
        return 'div';
    };
    BlockAtom = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.BLOCK_ATOM)
    ], BlockAtom);
    return BlockAtom;
}(Atom));
var InlineAtom = /** @class */ (function (_super) {
    __extends(InlineAtom, _super);
    function InlineAtom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs); };
        return _this;
    }
    InlineAtom.prototype.tagName = function (node) {
        return 'span';
    };
    InlineAtom = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.INLINE_ATOM)
    ], InlineAtom);
    return InlineAtom;
}(Atom));
// every plugin will generate a schemaMeta instance, it is actually can be
// used by ProseMirror, its `config` property is actually a SchemaSpec
var SchemaMeta = /** @class */ (function () {
    function SchemaMeta(formatType, name, config) {
        this.formatType = formatType;
        this.name = name;
        this.config = config;
    }
    SchemaMeta.prototype.getDisplay = function () {
        if (this.formatType & FORMAT_TYPE.INLINE) {
            if (this.formatType & FORMAT_TYPE.CARD || this.formatType & FORMAT_TYPE.ATOM) {
                return 'nodes';
            }
            return 'marks';
        }
        return 'nodes';
    };
    return SchemaMeta;
}());
export { Atom, Block, BlockAtom, Formattable, Inline, InlineAtom, SchemaMeta, SylSchema };
//# sourceMappingURL=schema.js.map